export type MockAccountState = "ACTIVE" | "ON_HOLD";

/** `mockAccount=on-hold` puts the whole mock account on hold; anything else is an active account. */
export function readMockAccount(asked: string | null, stored: string | null): MockAccountState {
  return (asked ?? stored) === "on-hold" ? "ON_HOLD" : "ACTIVE";
}
